export default {
    setup: false,
    loaders: [],
    log: [],
    logged_user: undefined
}